import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Box } from '@chakra-ui/react'; // Optional, for styling with Chakra UI

// Initialize highcharts-more to use the gauge feature
if (typeof Highcharts === 'object') {
	HighchartsMore(Highcharts);
}

const SpeedometerChart = ({ percentage }) => {
	const options = {
		chart: {
			type: 'gauge',
			plotBackgroundColor: null,  // No background
			plotBackgroundImage: null,
			plotBorderWidth: 0,
			plotShadow: false,
			height: '80%',
			backgroundColor: null // No background color
		},

		title: {
			text: null // Remove title
		},

		pane: {
			startAngle: -90,
			endAngle: 90,
			background: null,
			center: ['50%', '75%'],
			size: '110%'
		},

		yAxis: {
			min: 0,
			max: 100,
			tickPixelInterval: 72,
			tickPosition: 'inside',
			tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
			tickLength: 20,
			tickWidth: 2,
			minorTickInterval: null,
			labels: {
				distance: 20,
				style: {
					fontSize: '14px'
				}
			},
			lineWidth: 0,
			plotBands: [{
				from: 0,
				to: 20,
				color: '#DF5353', // Red
				thickness: 20
			}, {
				from: 20,
				to: 60,
				color: '#FF9655', // Orange
				thickness: 20
			}, {
				from: 60,
				to: 80,
				color: '#55BF3B', // Greenish
				thickness: 20
			}, {
				from: 80,
				to: 100,
				color: '#009900', // Green
				thickness: 20
			}]
		},

		series: [{
			name: 'Percentage',
			data: [100 - parseFloat(Math.ceil(percentage))],
			tooltip: {
				valueSuffix: `%`
			},
			dataLabels: {
				enabled: false, // Disable data labels to hide percentage
			},
			dial: {
				radius: '80%',
				backgroundColor: 'gray',
				baseWidth: 12,
				baseLength: '0%',
				rearLength: '0%'
			},
			pivot: {
				backgroundColor: 'gray',
				radius: 6
			}
		}],
		exporting: {
			enabled: false,
		},
		credits: {
			enabled: false // Disable Highcharts credits
		}
	};

	return (
		<Box maxWidth="350px" maxHeight="240px" margin="0 auto">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</Box>
	);
};

export default SpeedometerChart;
